import React, { memo, useMemo } from 'react'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setMaterial } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

const handleMaterialClick = (material) => {
  trackSettingsInteraction('material', material)
  setMaterial(material)
}

const handlePbrClick = () => handleMaterialClick(MATERIAL.PBR)
const handleBasicClick = () => handleMaterialClick(MATERIAL.BASIC)
const handleGeometryOnlyClick = () => handleMaterialClick(MATERIAL.GEOMETRY_ONLY)

function MaterialSelector() {
  const t = useTranslation()
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)
  const { isFullyDisabled, disabledValues } = useDisabledSelector('material', 'generationModelSchema')

  const buttons = useMemo(() => [
    {
      id: MATERIAL.PBR,
      label: t('leftSide.material.pbr'),
      onClick: handlePbrClick,
      disabled: isSmartLowPoly || isFullyDisabled || disabledValues.includes(MATERIAL.PBR),
    },
    {
      id: MATERIAL.BASIC,
      label: t('leftSide.material.basic'),
      onClick: handleBasicClick,
      disabled: isSmartLowPoly || isFullyDisabled || disabledValues.includes(MATERIAL.BASIC),
    },
    {
      id: MATERIAL.GEOMETRY_ONLY,
      label: t('leftSide.material.geometryOnly'),
      onClick: handleGeometryOnlyClick,
      disabled: isSmartLowPoly || isFullyDisabled || disabledValues.includes(MATERIAL.GEOMETRY_ONLY),
    },
  ], [isSmartLowPoly, isFullyDisabled, disabledValues, t])

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="material"
      sliceName="modelSettings"
      label={t('leftSide.material.label')}
    />
  )
}

export default memo(MaterialSelector)
